<template>
<v-app v-if="show">
    <Toolbar v-if="showToolbar" />
    <router-view />
    <v-footer class="pa-3">
        <v-spacer></v-spacer>
        <div>Yugpartner &copy; {{ new Date().getFullYear() }}</div>
        <v-spacer></v-spacer>
    </v-footer>
    <v-snackbar v-model="snackbar().model" :color="snackbar().color" :timeout="snackbar().timeout || 4000">
        <v-icon color="white">{{snackbar().icon}}</v-icon> {{snackbar().text}}
    </v-snackbar> 
</v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'

import {
    mapGetters
} from 'vuex'

export default {
    name: 'App',
    methods: {
        ...mapGetters(['snackbar']),
    },
    components: {
        Toolbar
    },
    data() {
        return {
            show: true,
        }
    },
    created() {
    },
    computed: {
        showToolbar() {
            return (this.$route.name == 'login' ? false : true)
        }
    }
}
</script>

<style>
</style>
